var React = require('react');

function NotificationBellLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43 40H5a1 1 0 010-2 2 2 0 002-2V23a17 17 0 1134 0v13a2 2 0 002 2 1 1 0 010 2zM8.47 38h31.07a4 4 0 01-.54-2V23a15 15 0 00-30 0v13a4 4 0 01-.53 2z","key":0}),React.createElement("path",{"d":"M24 8a1 1 0 01-1-1V1a1 1 0 112 0v6a1 1 0 01-1 1zm0 40a6 6 0 01-5.88-4.8 1.02 1.02 0 012-.4 4 4 0 007.84 0 1.02 1.02 0 012 .4A6 6 0 0124 48zm10-25a1 1 0 01-1-1 8 8 0 00-4.44-7.17 1 1 0 11.89-1.79 10 10 0 015.55 9 1 1 0 01-1 .96z","key":1})]);
}

NotificationBellLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = NotificationBellLight;

NotificationBellLight.default = NotificationBellLight;
